import * as React from "react";
import { Button, Space, Tooltip } from "antd";
import { MinusCircleOutlined, EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { NameValuePair } from "../../../schema/types/base";
import { store } from "../../../store";
import { formSet, formSetValue, formTriggerValidation, useCpFormValue } from "../../gvc/testNewForm/utils";
import { FormListFieldItem } from "../../gvc/formListFieldItem";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: NameValuePair;
  index?: number;
}
export const CpArrayItemDictionary: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index }) => {
  const { id } = useCpFormContext();
  const isEdit = useCpFormValue(`meta.isEdit`);
  const isVisible = useCpFormValue(`${_name!}.${_index!}.isVisible`);

  const name = _name!;
  const item = _item!;
  const index = _index!;

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;
    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i: any) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  const showToggle = isEdit;
  const inputType = showToggle && !isVisible ? "password" : "text";

  return (
    <FormListFieldItem columnCount={2} hasRemoveButton className="mb-1">
      <CpInput name={`${name}.${index}.name`} />
      {showToggle ? (
        <Space.Compact style={{ width: "100%" }}>
          <CpInput name={`${name}.${index}.value`} type={inputType} />
          <Tooltip title={isVisible ? "Hide" : "Show"}>
            <Button
              onClick={() => formSetValue(id, `${name}.${index}.isVisible`, !isVisible)}
              icon={isVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            />
          </Tooltip>
        </Space.Compact>
      ) : (
        <CpInput name={`${name}.${index}.value`} />
      )}
      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={remove} />
    </FormListFieldItem>
  );
});
